import styled from '@emotion/styled';

export default styled.h4`
  color: #757575;
  margin-bottom: 0;
  margin-left: 0.5rem;
`;
